module.exports = __webpack_public_path__ + "img/nyc-more-chrysler.f9e888c0.jpg";